import { SearchEngine } from "../../adapters/searchEngine";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(searchEngine: SearchEngine): Interactor {
  return (query) =>
    present(
      searchEngine
        .search(query)
        .then((results) => ({ results, query }))
        .catch(() => Promise.reject(query)),
    );
}

export type { Interactor };

export { createInteractor };
